import { Helmet } from 'react-helmet'

export default ({ Price, Id, initialCurrency, annualPrice, monthlyPrice }) =>
  <Helmet>
    <script>
      {
        `
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
              event: 'ContentView',
              content_ids: '${Id}',
              prixFormation: ${Price},
              currency: '${initialCurrency}',
              prixAbonnementMensuel: ${monthlyPrice},
              prixAbonnementAnnuel: ${annualPrice}
          });
        `
      }
    </script>
  </Helmet>
